import React from "react";
import ZkAddTemplateMsg from "./templateMsg/zkAddTemplateMsg";
import TaskposterUtil from "../ext/taskpost/taskposter_util";
import ZkStatisticsSpace from "./statistics/zkStatisticsSpace";
import ZkStatistics from "./statistics/zkStatistics";
import ZkForm from "./form/zkForm";
import ZkFormItem from "./form/zkFormItem";
import {Button, Input} from "antd";
import {DefaultUploadFile} from "../cmpts/uploadfile";
import ZKSideTab from "../cloud/common/zkSideTab/zkSideTab";
import ZKSideTabItem from "../cloud/common/zkSideTab/zkSideTabItem";
import ZKSideTabPane from "../cloud/common/zkSideTab/zkSideTabPane";
import ZKSideTabAdd from "../cloud/common/zkSideTab/zkSideTabAdd";

/**
 * @author Yaochao
 * @date 2021/8/4 16:18
 * @description
 */

const Msg = {
    "msg": {
        "url": "",
        "title": "任务完成通知",
        "data": {
            "first": {"value": "123"},
            "keyword1": {"value": "123"},
            "keyword2": {"value": "123"},
            "keyword3": {"value": "123"},
            "remark": {"value": "123"}
        },
        "content": "{{first.DATA}}TEMP_MXD_ENTER任务名称：{{keyword1.DATA}}TEMP_MXD_ENTER任务进度：{{keyword2.DATA}}TEMP_MXD_ENTER完成时间：{{keyword3.DATA}}TEMP_MXD_ENTER{{remark.DATA}}",
        "templateId": "Lztd4O3kZ3-o-osTdMMzXGKST2UywQkAFWSbbW70oz8",
        "miniprogram": {"appid": "", "pagepath": ""},
        "link": {"type": 0},
        "appId": "wx3687344d000b8e98"
    }
};

class Doc extends React.Component {

    constructor(props) {
        super(props);
        this.setNewMemberJoinMsgTm = this.setNewMemberJoinMsgTm.bind(this)
        this.state = {
            newMemberJoinMsgTm: '',
            subs: {
                appId: 'wx3687344d000b8e98',//公众号的ID
                nickName: '媒想到小卖部',//公众号的名称
                serviceType: 2,//服务号
                verifyType: 0,
                headImg: 'http://wx.qlogo.cn/mmopen/t6cpMpYeAkhIjyBs9Y5nD7IlOmNJKxsbKsgYRIMgjztsO71WhGUILXxq5gCzEUOL2K3CnMgsrBSJIK8iaicv7rNVhMjzkPkc3ic/0'
            },
            zkSideIndex: 0,
            zkSideData: [{
                title: 'tab1',
                content: 'content1'
            }, {
                title: 'tab2',
                content: 'content2'
            }]
        }
    }

    setNewMemberJoinMsgTm(msg) {
        // console.log(JSON.stringify(msg))
        // console.log(this.state.newMemberJoinMsgTm,'123231231')
        this.setState({
            newMemberJoinMsgTm: msg
        })
    }

    render() {

        return (
            <div style={{padding: '15px', height: '100%', overflow: 'auto'}}>
                <h1>模板消息添加组件</h1>
                <ZkAddTemplateMsg id="newMemberJoinTm"
                                  onChange={this.setNewMemberJoinMsgTm}
                                  msg={this.state.newMemberJoinMsgTm}
                                  vars={TaskposterUtil.getNewMemberJoinMsgVars()}
                                  subs={this.state.subs}/>
                <div className='clearfix'></div>
                <h1>数据统计组件</h1>
                <ZkStatisticsSpace className={'zkStatisticsWraper'}>
                    <ZkStatistics title='总客户数' tooltip='参与客户' value='200' vUnit='人'
                                  footer={[{value: '12', title: '今日'}, {value: '15', title: '昨日'}]}/>
                    <ZkStatistics title='总客户数' tooltip='参与客户' value='200' vUnit='人'
                                  footer={[{value: '12', title: '今日'}, {value: '15', title: '昨日'}]}/>
                    <ZkStatistics title='总客户数' tooltip='参与客户' value='200' vUnit='人'
                                  footer={[{value: '12', title: '今日'}, {value: '15', title: '昨日'}]}/>
                    <ZkStatistics title='总客户数' tooltip='参与客户' value='200' vUnit='人'
                                  footer={[{value: '12', title: '今日'}, {value: '15', title: '昨日'}]}/>
                </ZkStatisticsSpace>
                <ZkStatisticsSpace flexGrow={1}>
                    <ZkStatisticsSpace className={'zkStatisticsWraper'}>
                        <ZkStatistics title='总客户数' tooltip='参与客户' value='200' vUnit='人'
                                      footer={[{value: '12', title: '今日'}, {value: '15', title: '昨日'}]}/>
                        <ZkStatistics title='总客户数' tooltip='参与客户' value='200' vUnit='人'
                                      footer={[{value: '12', title: '今日'}, {value: '15', title: '昨日'}]}/>
                        <ZkStatistics title='总客户数' tooltip='参与客户' value='200' vUnit='人'
                                      footer={[{value: '12', title: '今日'}, {value: '15', title: '昨日'}]}/>
                    </ZkStatisticsSpace>
                    <ZkStatisticsSpace className={'zkStatisticsWraper'}>
                        <ZkStatistics title='总客户数' tooltip='参与客户' value='200' vUnit='人'
                                      footer={[{value: '12', title: '今日'}, {value: '15', title: '昨日'}]}/>
                        <ZkStatistics title='总客户数' tooltip='参与客户' value='200' vUnit='人'
                                      footer={[{value: '12', title: '今日'}, {value: '15', title: '昨日'}]}/>
                        <ZkStatistics title='总客户数' tooltip='参与客户' value='200' vUnit='人'
                                      footer={[{value: '12', title: '今日'}, {value: '15', title: '昨日'}]}/>
                    </ZkStatisticsSpace>
                </ZkStatisticsSpace>

                <h1>表单组件</h1>
                <ZkForm titleWidth={'150px'} conWidth={'380px'}>
                    <ZkFormItem title={'微信支付商户号'} colon={true} tooltip={'sdf'} required={true}>
                        <Input/>
                        <p className='lineHeight32'><a>如何获取微信支付商户号？</a></p>
                    </ZkFormItem>
                    <ZkFormItem title={'微信支付API证书'} colon={true} tooltip={'sdf'} required={true}>
                        <DefaultUploadFile btnText={'上传证书'}
                                           selectFile={this.selectCert}
                                           accept="p12"/>
                        <p><a>如何获取微信支付API证书</a></p>
                    </ZkFormItem>
                    <ZkFormItem conWidth={'500px'} title={'微信支付API密钥'} colon={true}
                                tooltip={'sdf'} required={true}>
                        <Input/>
                        <a>如何获取微信支付API密钥？</a>
                    </ZkFormItem>
                </ZkForm>
                <h1>侧边Tab组件</h1>
                <ZKSideTab activeIndex={this.state.zkSideIndex} delable={true} onChange={(index) => {
                    this.setState({
                        zkSideIndex: index
                    })
                }} onDelete={(index) => {
                    let zkSideData = this.state.zkSideData;
                    zkSideData.splice(index, 1);
                    this.setState({
                        zkSideData: zkSideData
                    })
                }}>
                    {
                        this.state.zkSideData.map((item) => {
                            return <ZKSideTabItem>
                                <div>
                                    {item.title}
                                </div>
                            </ZKSideTabItem>
                        })
                    }
                    <ZKSideTabAdd>
                        <Button onClick={() => {
                            let zkSideData = this.state.zkSideData;
                            zkSideData.push({
                                title: 'tab' + (zkSideData.length + 1),
                                content: 'content' + (zkSideData.length + 1)
                            });
                            this.setState({
                                zkSideData: zkSideData
                            })
                        }} type='primary'>添加Tab</Button>
                    </ZKSideTabAdd>
                    <ZKSideTabPane>
                        <div>
                            {
                                this.state.zkSideIndex < this.state.zkSideData.length ? this.state.zkSideData[this.state.zkSideIndex].content : ''
                            }
                        </div>
                    </ZKSideTabPane>
                </ZKSideTab>
            </div>
        )
    }
}

export default Doc